<template>
  <div :class="$style.usedRow">
    <div :class="$style.usedKey">
      {{ $t('home.availableBalance') }}
    </div>
    <Currency
      :class="$style.usedValue"
      :value="used"
    />
  </div>
  <ProgressBar
    :class="$style.progress"
    :value="progressBarValue"
  />
  <div :class="$style.row">
    {{ $t('home.limit') }}
    <Currency :value="info.limit" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

import Currency from '@/components/Currency.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import { info } from '@/store/mainInfo';

const used = computed(() => info.value.limit - info.value.remainLimit);
const progressBarValue = computed(() => (used.value / info.value.limit) * 100);
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.row {
  display: flex;
  justify-content: space-between;
}

.usedRow {
  composes: row;
  font-weight: bold;
  margin-bottom: 10px;
}

.usedKey {
  color: $color-black;
}

.usedValue {
  font-size: 15px;
  color: $color-black;
}

.progress {
  margin-bottom: 13px;
}
</style>
